/* eslint-disable @typescript-eslint/no-unused-vars */
import { useSelector } from "react-redux"
import { RootState } from "../../app/store"
import { Navigate } from "react-router-dom";

const PartnerRoutes = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, role } = useSelector((state: RootState) => state.auth);

    if (role === "admin") return <Navigate to="/" replace />

    return <>
        {children}
    </>
}


export default PartnerRoutes